import styled from "styled-components";
import { SLForm } from "~/pages/Sistema/componentes/SistemaList";
import { Colors } from "~/config/Colors";

export const Container = styled(SLForm)`
  width: 100%;
  max-width: 100%;

  .padding-form {
    padding: 0 1em 1em 1em;
  }

  .row {
    margin-bottom: 0.5em;
  }

  .header {
    padding: 0 0.6em;
    margin-bottom: 1em;

    .h-descricao {
      font-size: 0.7125em;
      line-height: 0.8em;
      color: ${Colors.Color7};
    }
  }

  
  .card-atv-header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 0.5em;

    .top-header {
      display: flex;
      justify-content: space-between;

      .titulo {
        display: flex;
        flex-direction: row;
        align-items: center;

        .fundo-icon {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          width: 1.40375em;
          height: 1.40375em;
          background: ${Colors.Color8};
          border-radius: 0.4375em;

          .atividade {
            width: 0.95em;
          }
        }

        .item {
          font-size: 0.75em;
          color: ${Colors.Color4};
          font-weight: 700;
          margin-left: 0.5em;
        }
      }
    }

    .icon-button {
      border: none;
      cursor: pointer;
      background: ${Colors.Color1};
      color: ${Colors.Color7};
      font-size: 1.125em;
    }
  }

  .card-atv-body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;

    .top-header {
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: center;
      height: 2em;
    }

    .padding-left {
      padding: 0;
      padding-left: 0.7em !important;
    }

    .row-top {
      margin-top: 0em !important;
      display: flex;
      flex-direction: row;
    }

    .geraProjeto {
    
      input, TextArea {
        width: 100%;
        margin-top: 0em !important;
      }
    }
  }

  
  .titulos-tab{
    display: flex;
    flex-direction: row;
    margin-bottom: 0.5em;
    background: ${Colors.Color8};
    color: ${Colors.Color7};
    border-radius: 0.5em;

    span {
      color: ${Colors.Color7};
    }

    .titulo {
      font-size: 0.6em;
      font-weight: 600;
      margin-left: 0.5em;
    }

    .col {
      height: 2.5em;
      padding: 0.5em 0em 0.5em 0.5em;
      display: flex;
      align-items: center;
    }

    .col1 {
      width: 5em;
    }
    
    .col2 {
      width: 10em;
    }
    
    .col3 {
      width: 15em;
    }
    
    .col4 {
      width: 20em;
    }
    
    .col5 {
      width: 25em;
    }
    
    .col6 {
      width: 30em;
    }
  }

`;